import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="modal-header">
			<h4 class="modal-title">{{ title }}</h4>
		</div>
    <div class="modal-body">{{ message }}</div>
    <div class="modal-footer">
      <button class="btn btn-dark" (click)="activeModal.close(true)">Confirm</button>
      <button class="btn btn-outline-dark" (click)="activeModal.close(false)">Cancel</button>
    </div>
  `
})
export class ConfirmDialogComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() name: string;

  activeModal = inject(NgbActiveModal);
}
